import { Attr, HasOne, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Organisation from "./Organisation";

@Model()
class OrganisationBrand extends ApplicationRecord {
  static jsonapiType = "organisation_brands";

  @Attr({ persist: false }) archivedAt: string;

  @Attr() backgroundColor: string;

  @Attr() coverageHeadlineColor: string;

  @Attr() coverageSummaryTextColor: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr() customDisclaimer: string;

  @Attr() dataTextColor: string;

  @Attr() dateColor: string;

  @Attr() emailSubject: string;

  @Attr() folderTextColor: string;

  @Attr() font: string;

  @Attr() footerImageUrl: string;

  @Attr() grayscaleLogoUrl: string;

  @Attr() headerImageUrl: string;

  @Attr() headerText: string;

  @Attr() hyperlinkTextColor: string;

  @Attr() internalUseOnly: boolean;

  @Attr() itemBodyTextColor: string;

  @Attr() keywordHighlightTextColor: string;

  @Attr() logoUrl: string;

  @Attr() name: string;

  @HasOne() organisation: Organisation;

  @Attr() organisationId: number;

  @Attr() organisationTeamId: number;

  @Attr() outreachFooterImageUrl: string;

  @Attr() outreachHeaderImageUrl: string;

  @Attr() primary: boolean;

  @Attr() themeColor: string;

  @Attr() type: string;

  hasAdvancedColors() {
    return (
      Boolean(this.coverageHeadlineColor) ||
      Boolean(this.folderTextColor) ||
      Boolean(this.dateColor) ||
      Boolean(this.dataTextColor) ||
      Boolean(this.hyperlinkTextColor) ||
      Boolean(this.itemBodyTextColor) ||
      Boolean(this.coverageSummaryTextColor) ||
      Boolean(this.backgroundColor) ||
      Boolean(this.keywordHighlightTextColor)
    );
  }
}

export default OrganisationBrand;
